import React from 'react';
import PropTypes from 'prop-types';
import CanPerform from 'components/shared/CanPerform';
import { CANCEL_VOUCHERS } from 'constants/afterSalesShortcuts';
import { FormattedMessage } from 'react-intl';
import { bookingShape, historyShape } from 'constants/propTypes';
import { withRouter } from 'react-router';
import { gql } from '@apollo/client';
import { useManagedMutation } from 'utils/managedHooks';
import Spinner from 'admin-components/components/Spinner';
import { CtaButton } from '../AfterSalesCtas.styles';
import config from 'utils/config';

const isCtaEnabled = config('ENABLE_CANCEL_VOUCHER_CTA', { canOverride: true }) === 'true';

const CREATE_VOUCHER_ONLY_BOOKING = gql`
  mutation createVoucherOnlyBooking($bookingReference: String!) {
    createVoucherOnlyBooking(bookingReference: $bookingReference) {
      reference
      totalPriceToBePaid
      currency
    }
  }
`;

const CancelVouchersCta = ({ booking, history: { push }, disabled }) => {
  const [createVoucherOnlyBooking, { loading: createBookingLoading }] = useManagedMutation(CREATE_VOUCHER_ONLY_BOOKING, {
    variables: {
      bookingReference: booking.reference
    }
  });

  const handleSubmit = async () => {
    const { data: newBooking } = await createVoucherOnlyBooking();
    const { reference, totalPriceToBePaid } = newBooking.createVoucherOnlyBooking;
    if (totalPriceToBePaid > 0) {
      push(`/booking/${reference}/payment?cancel-voucher&currency=${booking.currency}&sendRedeemEmail=false`);
    } else {
      push(`/manage/bookings/${reference}/journeys`);
    }
  };

  if (createBookingLoading) {
    return <Spinner />;
  }

  return (
    <>
      <CanPerform afterSalesShortcut={CANCEL_VOUCHERS}>
        {(isEligible) =>
          isCtaEnabled &&
          isEligible && (
            <CtaButton
              onClick={handleSubmit}
              data-cy="refund-vouchers-cta"
              label={<FormattedMessage id="afterSales.cancelVouchers" />}
              disabled={disabled}
            />
          )
        }
      </CanPerform>
    </>
  );
};

CancelVouchersCta.propTypes = {
  booking: bookingShape,
  disabled: PropTypes.bool,
  history: historyShape
};

export default withRouter(CancelVouchersCta);
